import { cn } from '../../lib/utils';

interface LoadingSkeletonProps {
  className?: string;
}

export function LoadingSkeleton({ className }: LoadingSkeletonProps) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-slate-200',
        className
      )}
      aria-hidden="true"
    />
  );
}

export function AgentCardSkeleton() {
  return (
    <div className="rounded-lg border bg-white p-6 shadow-sm">
      <div className="flex items-start gap-4">
        <LoadingSkeleton className="h-12 w-12 rounded-lg" />
        <div className="flex-1 space-y-3">
          <LoadingSkeleton className="h-5 w-1/3" />
          <LoadingSkeleton className="h-4 w-2/3" />
          <div className="flex gap-2">
            <LoadingSkeleton className="h-6 w-16 rounded-full" />
            <LoadingSkeleton className="h-6 w-24 rounded-full" />
          </div>
        </div>
        <div className="flex gap-2">
          <LoadingSkeleton className="h-9 w-20" />
          <LoadingSkeleton className="h-9 w-16" />
          <LoadingSkeleton className="h-9 w-16" />
        </div>
      </div>
    </div>
  );
}

export function AgentListSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <AgentCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function AgentDetailSkeleton() {
  return (
    <div className="space-y-6">
      <div className="flex items-start gap-4">
        <LoadingSkeleton className="h-16 w-16 rounded-lg" />
        <div className="flex-1 space-y-3">
          <LoadingSkeleton className="h-8 w-1/3" />
          <LoadingSkeleton className="h-4 w-1/2" />
        </div>
      </div>
      <div className="grid gap-4 md:grid-cols-3">
        <LoadingSkeleton className="h-24" />
        <LoadingSkeleton className="h-24" />
        <LoadingSkeleton className="h-24" />
      </div>
      <LoadingSkeleton className="h-48" />
    </div>
  );
}

export default LoadingSkeleton;
